import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.css'],
})
export class TimerComponent implements OnChanges, OnDestroy {
  @Input() totalSeconds?: number;
  @Input() startSeconds?: number;

  countdownRemaining = 0;

  private intervalId: ReturnType<typeof setInterval> | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['startSeconds']) {
      this.startCountdown();
    }
  }

  private startCountdown(): void {
    this.clearTimer();

    this.countdownRemaining = this.startSeconds ?? 0;

    this.intervalId = setInterval(() => {
      if (this.countdownRemaining > 0) {
        this.countdownRemaining--;
      } else {
        this.clearTimer();
      }
    }, 1000);
  }

  get progressBackground(): string {
    const deg = (this.countdownRemaining / (this.totalSeconds || 1)) * 360;

    const color = this.countdownRemaining <= 10 ? '#ef4444' : '#2563eb';

    return `conic-gradient(${color} ${deg}deg, #e2e8f0 ${deg}deg)`;
  }

  private clearTimer(): void {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }
}
